import * as React from 'react';

import { Box } from '@coursera/coursera-ui';

import ToggleSwitch from 'bundles/account-settings/components/sections/highlights/ToggleSwitch';

import 'css!./__styles__/ToggleContainer';

type Props = {
  onText: string;
  offText: string;
  onToggle: (newStatus: 'on' | 'off') => void;
  enabled?: boolean;
  ariaLabel?: string;
  ariaDescribedBy?: string;
};

const ToggleContainer = ({ onText, offText, onToggle, enabled, ariaLabel, ariaDescribedBy }: Props) => {
  return (
    <Box alignItems="center" justifyContent="center" rootClassName="rc-ToggleContainer">
      {offText}
      <ToggleSwitch
        onToggle={onToggle}
        value={enabled ? ToggleSwitch.getStatus().On : ToggleSwitch.getStatus().Off}
        ariaLabel={ariaLabel}
        ariaDescribedBy={ariaDescribedBy}
        hideStatusText
      />
      {onText}
    </Box>
  );
};

export default ToggleContainer;
